export default __webpack_public_path__ + "static/media/info-circle.646df8f7.svg";